/*!
 * @license
 * Copyright 2019 Alfresco, Inc. and/or its affiliates.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { CardViewItemValidator } from '@alfresco/adf-core';
import { MODELER_NAME_REGEX } from '../helpers/utils/create-entries-names';

export class CardViewModelNameValidator implements CardViewItemValidator {

    constructor(public message: string) {}

    isValid(value: string): boolean {
        return value.length > 0 && MODELER_NAME_REGEX.test(value);
    }
}
